<template>
  <div class="about" >
    <b-container class="page-container">
      <b-row>
        <b-col md="1"></b-col>
        <h1 class="title" style="padding-left: 10px">About</h1>
      </b-row>
      <b-row>
        <b-col md="1"></b-col>
        <b-breadcrumb :items="items"/>
      </b-row>
      <hr>
      <br>
      <b-row>
        <b-col md="1" cols="2"></b-col>
        <b-col md="4">
          <div style=" padding: 15px;">
            <b-img src="http://www.finitegames.com/images/GF_Logo_Full.png" thumbnail fluid class="thumbnail" style="max-height: 300px;"/>
          </div>
        </b-col>
        <b-col md="6">
          <div>
            <h2>About Finite Games</h2>
            <br>
              <p class="text-left">
                Founded in 2016 in Syracuse NY, Finite Games is dedicated to exploring the endless possibilities of Virtual Reality. Technological leaps of this scale are rare, my hope is to contribute to this new medium by creating quality content with an unprecidented level of immersion.
              </p>
            <br>
          </div>
        </b-col>
        <b-col md="2"></b-col>
      </b-row>
       <hr>
      <b-row>
        <b-col md="1"></b-col>
        <b-col md="10">
          <div>
            <h2>About Me</h2>
            <br>
              <p class="text-left">
                My name is Conor Donahoe, I'm a software developer by trade who spends all of his free time making games.  I've always had trouble choosing a class in RPGs, I just wanted to be able to do everything.  That mentality comes in handy on solo projects like Exurgo.  I fill the roles of Designer, Programmer, 3D Modeler, Graphic Designer, Animator, Sound Engineer, Marketing, UX Designer and Project Manager.  There's always a new challenge to tackle, thankfully I never liked sleeping much anyway.
              </p>
            <br>
          </div>
        </b-col>
        <b-col md="1"></b-col>
      </b-row>

      <b-row>
        <b-col md="1"></b-col>
          <b-col md="10">
            <div>
              <b-img src="http://www.finitegames.com/images/finitegames_vive.jpg" thumbnail fluid class="thumbnail"/>
            </div>
          </b-col>
        <b-col md="1"></b-col>
      </b-row>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
    </b-container>
    </div>
</template>
<script>
export default {
  name: 'about',
  data () {
    return {
      items: [
        {text: 'Home', to: '/'},
        {text: 'About', active: true}
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/About.vue